import { Node } from './node';
import {
  HEIGHT_COMPONENT_ITEM,
  NavigatorDropType,
  NodeModelTypes,
} from '../utils/consts';
import { NodeModel } from './types';
import type { Tree } from './tree';

export const CREATE_COMPONENT_NODE_ID = '__create_component__';

class CreateComponentNode extends Node {
  private _id = CREATE_COMPONENT_NODE_ID;

  constructor(tree: Tree) {
    super(tree, null);
  }

  override get id() {
    return this._id;
  }

  override get type() {
    return NodeModelTypes.CREATE_COMPONENT;
  }

  override get hasWriteAccess() {
    return false;
  }

  override get isSelectable() {
    return false;
  }

  getChildren(): NodeModel[] {
    return [];
  }

  hasChildren() {
    return false;
  }

  updateChildren() {
    // No children to update.
  }

  override getItemHeight() {
    return HEIGHT_COMPONENT_ITEM;
  }

  override isIncludedInContextByFilter() {
    return true;
  }

  override canHaveChildren() {
    return false;
  }

  override getName() {
    return this.tree.getRawFilterTerm() ?? '';
  }

  override getDropTypeForNode(_draggedNode: NodeModel) {
    return NavigatorDropType.DROP_TYPE_NO_DROP as const;
  }
}

export { CreateComponentNode };
